export var ACTION;
(function (ACTION) {
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["NAVIGATION"] = "NAVIGATION";
    ACTION["GO_TO_EMAIL"] = "GO_TO_EMAIL";
    ACTION["SUBMIT_APPROVAL"] = "SUBMIT_APPROVAL";
    ACTION["PRESIGN_ACTION"] = "PRESIGN_ACTION";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["GO_BACK_HEADER"] = "GO_BACK_HEADER";
    ACTION["UPLOAD_FAILED"] = "UPLOAD_FAILED";
})(ACTION || (ACTION = {}));
